import apiClient from './api_client_requests';

export default async (payload) => {
    await apiClient.apiMethod({
        method: 'PlayerLogout',
        args: {
            logout: 1,
        },
    });

    return {
        loggedIn: false,
    };
};
